(() => {
  const drawer = document.getElementById('pr-cart-drawer');
  if (!drawer || !drawer.showModal) return;
  const root = window.Shopify?.routes?.root || '/';
  const strings = JSON.parse(document.getElementById('pr-cart-strings').textContent);
  const status = drawer.querySelector('.prcd-status');
  let busy = false, previousFocus;
  function announce(message, success = false) {
    status.classList.remove('prcd-status-success');
    status.textContent = message;
    if (success) status.classList.add('prcd-status-success');
  }
  const setBusy = value => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('.pr-cart-express').forEach(el => el.inert = value);
    drawer.querySelectorAll('[data-pr-quantity], [data-pr-remove], [data-pr-step], [name=checkout]').forEach(el => el.disabled = value);
  };
  async function render() {
    const response = await fetch(root + '?section_id=pr-cart-drawer', {cache:'no-store'});
    if (!response.ok) throw new Error(strings.error);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = doc.getElementById('pr-cart-content');
    if (!content) throw new Error(strings.error);
    drawer.querySelector('#pr-cart-content').replaceWith(content);
    drawer.querySelector('#pr-cart-title').innerHTML = doc.getElementById('pr-cart-title').innerHTML;
    document.querySelectorAll('.tt-badge-cart').forEach(el => {el.textContent=content.dataset.count;el.classList.toggle('hide',Number(content.dataset.count)===0);});
  }
  function show() {
    if (!drawer.open) {previousFocus=document.activeElement;drawer.showModal();document.documentElement.classList.add('pr-cart-open');}
  }
  async function open() {
    show();
    if (busy) return;
    setBusy(true);announce(strings.loading);
    try {await render();announce('');} catch(e) {announce(strings.error);} finally {setBusy(false);}
  }
  window.PRCartDrawer = {open};
  drawer.addEventListener('close', () => {document.documentElement.classList.remove('pr-cart-open');if(previousFocus?.isConnected)previousFocus.focus();});
  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-pr-close]')) drawer.close();
    if(event.target===drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right)drawer.close();}
    const step=event.target.closest('[data-pr-step]');if(step){const input=step.closest('[data-key]').querySelector('[data-pr-quantity]');change(step,Math.max(0,Number(input.value)+Number(step.dataset.prStep)));}
    const remove=event.target.closest('[data-pr-remove]');if(remove)change(remove,0);
  });
  drawer.addEventListener('change', event => {if(event.target.matches('[data-pr-quantity]'))change(event.target,Number(event.target.value));});
  async function change(control, quantity) {
    if(busy) return;
    if(!Number.isInteger(quantity)||quantity<0){control.value=control.defaultValue;return;}
    const key=control.closest('[data-key]').dataset.key;
    setBusy(true);announce(strings.loading);
    try {
      const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
      const data=await response.json();
      if(!response.ok)throw new Error(data.description||data.message||strings.error);
      await render();announce(strings.updated, true);
    }catch(e){announce(e.message);try{await render();}catch(_) {}}
    finally{setBusy(false);const line=Array.from(drawer.querySelectorAll('[data-key]')).find(el=>el.dataset.key===key);(line?.querySelector('[data-pr-quantity]')||drawer.querySelector('[data-pr-close]')).focus();}
  }
  document.addEventListener('click', event => {
    if(event.defaultPrevented||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey) return;
    const trigger=event.target.closest('.tt-cart > .tt-dropdown-toggle, header a[href="/cart"]');
    if(!trigger||drawer.contains(trigger))return;
    event.preventDefault();event.stopImmediatePropagation();open();
  },true);
  if (window.jQuery) {
    window.jQuery(document).on('show.bs.modal.prCartDrawer', '#modalAddToCartProduct', function(event) {
      event.preventDefault();
      open();
    });
  }
})();
